import { render, staticRenderFns } from "./PoomsaeAdmin.vue?vue&type=template&id=5ee16b63&scoped=true"
import script from "./PoomsaeAdmin.vue?vue&type=script&lang=js"
export * from "./PoomsaeAdmin.vue?vue&type=script&lang=js"
import style0 from "./PoomsaeAdmin.vue?vue&type=style&index=0&id=5ee16b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee16b63",
  null
  
)

export default component.exports